import * as React from "react"
import Header from "./header"
import Footer from "./footer"
import {
  wrapper,
  wrapperInnerDetail,
} from "../styles/layout.module.scss"

const LayoutDetail = ({ location, children }) => {
// console.log('----- children ------', children)
// console.log('----- location ------', location)
const className = location.pathname === '/wumbolytics/' ? 'mt-[70px] bg-[#F4F4F4] text-black' : ' mt-[70px] bg-white text-black';
  return (
    <div className={wrapper}>
      <Header location={location} />
      <div className={wrapperInnerDetail}>
        <main className={className}>
          {children}
        </main>
      </div>
      <Footer location={location} pathname={location.pathname} />
    </div>
  )
}

export default LayoutDetail
